

const dummyData = [
    {
      label: 'Dashboard',
      key: '1',
      icon: 'PieChartOutlined',
      type: 'item',
      link: '/',
    },
    {
      label: 'Departments',
      key: '2',
      icon: 'PieChartOutlined',
      type: 'item',
      link: '/departments',
    },
    {
      label: 'Master',
      key: 'sub1',
      icon: 'PieChartOutlined',
      type: 'submenu',
      children: [
        {
          label: 'User',
          key: '7',
          icon: 'ContainerOutlined',
          type: 'item',
          link: '/users',
        },
        {
          label: 'Departments',
          key: '8',
          icon: 'ContainerOutlined',
          type: 'item',
          link: '/department_master',
        },
        {
          label: 'Category',
          key: '9',
          icon: 'ContainerOutlined',
          type: 'item',
          link: '/category_master',
        },
        {
          label: 'Menu Items',
          key: '10',
          icon: 'ContainerOutlined',
          type: 'item',
          link: '/menu',
        },
      ],
    },
  ];
  
  export default dummyData;
  